import React from "react";
import { Grid, TextField, Button, Paper } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

export const FilterBar = ({ desde, hasta, setDesde, setHasta, onActualizar, loading }) => (
  <Paper elevation={0} sx={{ p: 2, mb: 1, border: "1px solid #e0e0e0", borderRadius: 1 }}>
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={5}>
        <TextField
          fullWidth
          size="small"
          label="Desde"
          type="date"
          value={desde}
          onChange={(e) => setDesde(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ bgcolor: "#fff" }}
        />
      </Grid>
      <Grid item xs={12} md={5}>
        <TextField
          fullWidth
          size="small"
          label="Hasta"
          type="date"
          value={hasta}
          onChange={(e) => setHasta(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ bgcolor: "#fff" }}
        />
      </Grid>
      <Grid item xs={12} md={2}>
        <Button
          fullWidth
          variant="contained"
          onClick={onActualizar}
          disabled={loading}
          startIcon={<RefreshIcon />}
          sx={{
            py: 0.75,
            textTransform: "none",
            fontWeight: 500,
          }}
        >
          {loading ? "Cargando..." : "Actualizar"}
        </Button>
      </Grid>
    </Grid>
  </Paper>
);